var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgCalculator = function SvgCalculator(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconspace_Calculator-1",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2863",
    "data-name": "Group 2863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4422",
    className: "a",
    "data-name": "Path 4422",
    d: "M7.291,1.818A.909.909,0,0,1,7.291,0h9.981A2.727,2.727,0,0,1,20,2.727V17.273A2.727,2.727,0,0,1,17.273,20H2.727A2.727,2.727,0,0,1,0,17.273V2.727A2.727,2.727,0,0,1,2.727,0h.912a.909.909,0,0,1,0,1.818H2.727a.909.909,0,0,0-.909.909V17.273a.909.909,0,0,0,.909.909H17.273a.909.909,0,0,0,.909-.909V2.727a.909.909,0,0,0-.909-.909Z",
    transform: "translate(0 0)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2865",
    "data-name": "Group 2865",
    transform: "translate(2.727 2.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4423",
    className: "a",
    "data-name": "Path 4423",
    d: "M16.636,3H3.909A.909.909,0,0,0,3,3.909V8.455a.909.909,0,0,0,.909.909H16.636a.909.909,0,0,0,.909-.909V3.909A.909.909,0,0,0,16.636,3L4.818,7.545V4.818H15.727V7.545H4.818Z",
    transform: "translate(-3 -3)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866",
    transform: "translate(2.727 10.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4424",
    className: "a",
    "data-name": "Path 4424",
    d: "M5.727,12a.909.909,0,0,1,0,1.818H3.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-3 -12)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2867",
    "data-name": "Group 2867",
    transform: "translate(13.636 10.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4425",
    className: "a",
    "data-name": "Path 4425",
    d: "M17.727,12a.909.909,0,0,1,0,1.818H15.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-15 -12)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2868",
    "data-name": "Group 2868",
    transform: "translate(8.182 10.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4426",
    className: "a",
    "data-name": "Path 4426",
    d: "M11.727,12a.909.909,0,1,1,0,1.818H9.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-9 -12)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2869",
    "data-name": "Group 2869",
    transform: "translate(2.727 14.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4427",
    className: "a",
    "data-name": "Path 4427",
    d: "M5.727,16a.909.909,0,0,1,0,1.818H3.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-3 -16)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2870",
    "data-name": "Group 2870",
    transform: "translate(13.636 14.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4428",
    className: "a",
    "data-name": "Path 4428",
    d: "M17.727,16a.909.909,0,0,1,0,1.818H15.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-15 -16)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2871",
    "data-name": "Group 2871",
    transform: "translate(8.182 14.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4429",
    className: "a",
    "data-name": "Path 4429",
    d: "M11.727,16a.909.909,0,1,1,0,1.818H9.909a.909.909,0,0,1,0-1.818Z",
    transform: "translate(-9 -16)",
    fill: "#2254b9",
    fillRule: "evenodd"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator.ea71147a.svg";
export { ForwardRef as ReactComponent };